;(function($, undefined){
    'use strict';

    var rnn = window.rnn,
        optionPickerSelector = '.picker';

    function createOptionPicker(){
        var picker = $(this),
            select = picker.find('select'),
            proxy;

        proxy = $.el.div({'class':'proxy'},
            $.el.span({'class':'pickerLabel'}, select.find('option:selected').text() || select.find('option').first().text()),
            $.el.span({'class':'dropdown'},
                $.el.span({'class':'caret'})
            )
        );

        picker.prepend(proxy);
    }

    function handleOptionChange(event){
        var target = $(event.target),
            picker = target.closest(optionPickerSelector),
            select = picker.find('select'),
            option = select.find('option:selected'),
            label = picker.find('.pickerLabel');

        label.text(option.text());
    }

    function initEvents(){
        $(document).on('change', '.picker select',handleOptionChange);
    }

    function initOptionPickers(){
        $(optionPickerSelector).each(createOptionPicker);

        initEvents();
    }

    rnn.modules.register('optionPicker', {
        init: initOptionPickers,
        create: function(target){
            $(target).each(createOptionPicker);
        }
    });

})(jQuery);
